// src/components/HowItWorksSection.jsx
import React from 'react';

const HowItWorksSection = (props) => {
    const content = props.content || {};
    return (
        <section id="how-it-works" className="bg-pf-bgDarker w-full relative flex flex-col items-center justify-center md:p-20 py-6">

            {/* Content */}
            <div className="flex flex-col justify-between md:justify-center items-center w-full h-full z-10">
                <div className="text-center">
                    <h1 className="text-pf-titleDark text-subtitle-sm md:text-subtitle">
                        {content.howItWorks.title}
                    </h1>
                </div>
            </div>
            <div className="wrapper flex-row md:flex-nowrap flex-wrap justify-center items-center md:space-x-6">
                {content.howItWorks.steps.map((step, index) => (
                    <div key={index} className="w-full md:w-1/3 flex flex-col items-center justify-start py-3 md:py-0">
                        <div className="w-16 h-16 mt-6 flex items-center justify-center rounded-full bg-pf-bglight text-pf-titleDark text-4xl font-semibold">
                            {step.item.label}
                        </div>
                        <div className='flex flex-col items-center justify-center py-4'>
                            <div className="text-lg font-medium text-pf-titleDark w-9/12 md:w-11/12 text-center pb-1">
                                {step.item.title}
                            </div>
                        </div>
                    <div className='relative w-full h-auto overflow-hidden'>
                        <img src={step.item.imageUrl} alt={step.item.label} className=" w-full h-auto object-contain" />
                    </div>
                </div>
                ))}
            </div>
        </section>
    );
};

export default HowItWorksSection;